import { z } from 'zod';
import { CustomerDataSchema } from '../customer';
import { EmployeeSchema } from '../employee';
import { MobileServiceSchema } from '../mobile-services';
import { ProductDataSchema, ProductTypeSchema } from '../products/base';
import { SaleItemMetadataSchema } from '../sale';
import { SalesChannelEnum, SalesChannelSchema } from '../sale/meta';
import { SourceStatusSchema, } from '../status';
import { ZodStringToDate } from '../system';
import { FinancialDataSchema } from './base';
import { SaleOrderDetailsSchema } from '../sale/order-details';
export const CheckoutDetailsSchema = z.object({
    date: ZodStringToDate,
    dueDate: ZodStringToDate.nullable(),
    terms: z.string(),
    // Radios
    displayLogo: z.boolean(),
    lateFeesEnabled: z.boolean(),
    enableTaxes: z.boolean(),
    clientPaysFees: z.boolean(),
    customerNotes: z.string().nullable(),
    /** @deprecated Use checkout.orderDetails.orderNumber. */
    orderNumber: z
        .string()
        .nullable()
        .describe('@deprecated Use checkout.orderDetails.orderNumber'),
    /** @deprecated Use checkout.orderDetails.requiresOrderProcessing. */
    requiresOrderProcessing: z
        .boolean()
        .describe('@deprecated Use checkout.orderDetails.requiresOrderProcessing'),
    syncedToQuickBooks: z.boolean().optional().default(false),
});
export const CheckoutItemSchema = z.object({
    id: z.string(),
    identifier: z.string(),
    name: z.string(),
    price: z.number(),
    cost: z.number(),
    quantity: z.number(),
    linkedProduct: ProductDataSchema.nullable(),
    linkedMobileService: MobileServiceSchema.nullable(),
    productType: ProductTypeSchema.nullable(),
    metadata: SaleItemMetadataSchema.optional(),
});
/// Schema for system, which contains defaults for the app
export const CheckoutSchema = z.object({
    id: z.string(),
    shortIdentifier: z.string(),
    isInvoice: z.boolean(),
    isPosSale: z.boolean(),
    isMbsSale: z.boolean(),
    salesChannel: SalesChannelSchema.default(SalesChannelEnum.POS),
    currentInput: z.string().nullable(),
    businessLocationId: z.string(),
    isCreated: z.boolean(),
    isCompleted: z.boolean(),
    isReadyToPay: z.boolean(),
    //
    details: CheckoutDetailsSchema,
    orderDetails: SaleOrderDetailsSchema.nullable().optional(),
    status: SourceStatusSchema.nullable(),
    financialInfo: FinancialDataSchema,
    customerInfo: CustomerDataSchema.nullable(),
    employee: EmployeeSchema,
    items: CheckoutItemSchema.array(),
});
export const CheckoutManagerTypeSchema = z.object({
    currentCheckout: CheckoutSchema,
    pendingCheckoutList: z.array(CheckoutSchema),
});
